import cssEscape from "~/utils/cssEscape";

const colors = {
  landingOwner: "#4090F2",
  landingTenant: "#F0CFB2",
} as const;

export type LandingColors = keyof typeof colors;

const innerHouseSVG = (
  color: string,
) => `<svg xmlns="http://www.w3.org/2000/svg" width="1176" height="1123" viewBox="0 0 1176 1123" fill="none">
<path d="M523.482 28.096C560.756 -3.22636 615.243 -3.22636 652.518 28.0961L1135.47 433.929C1158.04 452.893 1171.06 480.817 1171.06 510.238L1171.06 1018.59C1171.06 1073.7 1126.25 1118.4 1070.95 1118.4L105.047 1118.4C49.748 1118.4 4.93945 1073.7 4.93945 1018.59L4.93945 510.238C4.93945 480.818 17.9608 452.893 40.5288 433.929L523.482 28.096Z" stroke="${color}" stroke-width="8"/>
</svg>`;

const outerHouseSVG = (
  color: string,
) => `<svg xmlns="http://www.w3.org/2000/svg" width="1402" height="1349" viewBox="0 0 1402 1349" fill="none">
<path d="M563.054 54.2284C642.752 -12.7429 759.248 -12.7427 838.946 54.2285L1321.9 460.061C1370.15 500.611 1398 560.323 1398 623.238L1398 1131.59C1398 1249.44 1302.18 1345 1183.95 1345L218.047 1345C99.821 1345 4 1249.44 4 1131.59L4 623.238C4 560.323 31.8458 500.611 80.1012 460.061L563.054 54.2284Z" stroke="${color}" stroke-width="8"/>
</svg>`;

const dataImg = (url: string) => `url("data:image/svg+xml,${cssEscape(url)}")`;

export const innerHouse = (color: string) => dataImg(innerHouseSVG(color));
export const outerHouse = (color: string) => dataImg(outerHouseSVG(color));
